export const fieldsInitials = {
  INPUT_SINGLE_LINE_TEXT: {
    label: {
      value: "Type a question",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    input: {
      data: {
        contentType: "placeholder",
        defaultText: "Default Text",
        placeholder: "Placeholder",
      },
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#fff",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#fff",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#434e5a33",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434e5a33",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "16",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    isRequired: { value: false, message: "" },
    tooltip: { enabled: false, text: "" },
    validations: {
      LETTERS: { value: false, enabled: false, message: "" },
      DIGITS: { value: false, enabled: false, message: "" },
      EMAIL: { value: false, enabled: false, message: "" },
      URL: { value: false, enabled: false, message: "" },
      REGEX: {
        value: " ",
        enabled: false,
        message: "Write your regex error message.",
      },
      MIN_MAX_STRING_LENGTH: {
        enabled: false,
        min: 0,
        max: 0,
        validateBy: "LENGTH",
        message: "",
      },
    },
  },
  INPUT_MULTI_LINE_TEXT: {
    label: {
      value: "Type a question",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    input: {
      data: {
        contentType: "placeholder",
        defaultText: "",
        placeholder: "",
      },
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#fff",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#fff",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#434e5a33",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434e5a33",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "16",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    isRequired: { value: false, message: "" },
    isRichText: false,
    tooltip: { enabled: false, text: "" },
    validations: {
      LETTERS: { value: false, enabled: false, message: "" },
      DIGITS: { value: false, enabled: false, message: "" },
      URL: { value: false, enabled: false, message: "" },
      REGEX: {
        value: " ",
        enabled: false,
        message: "Write your regex error message.",
      },
      EMAIL: { value: false, enabled: false, message: "" },
      MIN_MAX_STRING_LENGTH: {
        enabled: false,
        min: 0,
        max: 0,
        validateBy: "LENGTH",
        message: "",
      },
    },
  },
  INPUT_NAME: {
    label: {
      value: "Name",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    isShowLabel: true,
    isRequired: { value: false, message: "" },
    isMiddleName: false,
    tooltip: { enabled: false, text: "" },
    first_name: {
      input: {
        data: {
          contentType: "placeholder",
          defaultText: "Default Text",
          placeholder: "First name",
        },
        styles: {
          input: {
            widthPx: null,
            widthPercent: 45,
            height: 44,
            widthMeasurement: "Percent",
            fill: {
              color: {
                isStyleVisible: true,
                solid: "#fff",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#fff",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 255,
                    green: 255,
                    hue: 0,
                    red: 255,
                    saturation: 0,
                    value: 100,
                  },
                },
              },
            },
            border: {
              radius: 8,
              size: 1,
              color: {
                isStyleVisible: true,
                solid: "#434e5a33",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#434e5a33",
                  type: 0,
                  value: {
                    alpha: 0.2,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
          },
          inputValue: {
            family: "Quicksand",
            weight: "400",
            size: "16",
            isItalic: false,
            isUnderline: false,
            isStrikethrough: false,
            alignment: "left",
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 0.6,
                  blue: 90,
                  green: 78,
                  hue: 0,
                  red: 67,
                  saturation: 0,
                  value: 97,
                },
              },
            },
          },
        },
      },
      isRequired: { value: false, message: "" },
    },
    middle_name: {
      input: {
        data: {
          contentType: "placeholder",
          defaultText: "Default Text",
          placeholder: "Middle Name",
        },
        styles: {
          input: {
            widthPx: null,
            widthPercent: 45,
            height: 44,
            widthMeasurement: "Percent",
            fill: {
              color: {
                isStyleVisible: true,
                solid: "#fff",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#fff",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 255,
                    green: 255,
                    hue: 0,
                    red: 255,
                    saturation: 0,
                    value: 100,
                  },
                },
              },
            },
            border: {
              radius: 8,
              size: 1,
              color: {
                isStyleVisible: true,
                solid: "#434e5a33",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#434e5a33",
                  type: 0,
                  value: {
                    alpha: 0.2,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
          },
          inputValue: {
            family: "Quicksand",
            weight: "400",
            size: "16",
            isItalic: false,
            isUnderline: false,
            isStrikethrough: false,
            alignment: "left",
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 0.6,
                  blue: 90,
                  green: 78,
                  hue: 0,
                  red: 67,
                  saturation: 0,
                  value: 97,
                },
              },
            },
          },
        },
      },
      isRequired: { value: false, message: "" },
    },
    last_name: {
      input: {
        data: {
          contentType: "placeholder",
          defaultText: "Default Text",
          placeholder: "Last name",
        },
        styles: {
          input: {
            widthPx: null,
            widthPercent: 45,
            height: 44,
            widthMeasurement: "Percent",
            fill: {
              color: {
                isStyleVisible: true,
                solid: "#fff",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#fff",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 255,
                    green: 255,
                    hue: 0,
                    red: 255,
                    saturation: 0,
                    value: 100,
                  },
                },
              },
            },
            border: {
              radius: 8,
              size: 1,
              color: {
                isStyleVisible: true,
                solid: "#434e5a33",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#434e5a33",
                  type: 0,
                  value: {
                    alpha: 0.2,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
          },
          inputValue: {
            family: "Quicksand",
            weight: "400",
            size: "16",
            isItalic: false,
            isUnderline: false,
            isStrikethrough: false,
            alignment: "left",
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 0.6,
                  blue: 90,
                  green: 78,
                  hue: 0,
                  red: 67,
                  saturation: 0,
                  value: 97,
                },
              },
            },
          },
        },
      },
      isRequired: { value: false, message: "" },
    },
    validations: {},
  },
  INPUT_PASSWORD: {
    label: {
      value: "Password",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    isShowLabel: true,
    isRequired: { value: false, message: "" },
    tooltip: { enabled: false, text: "" },
    input: {
      data: { placeholder: "Enter Password" },
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#fff",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#fff",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#434e5a33",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434e5a33",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "16",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    validations: {
      LETTERS: { value: false, enabled: false, message: "" },
      REGEX: {
        value: " ",
        enabled: false,
        message: "Write your regex error message.",
      },
      MIN_MAX_STRING_LENGTH: {
        min: 0,
        max: 0,
        validateBy: "WORD",
        enabled: false,
        message: "",
      },
      DIGITS: { value: false, enabled: false, message: "" },
    },
    icon: {
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#33bfa1",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#33bfa1",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "20",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
  },
  INPUT_PHONE: {
    label: {
      value: "Phone",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    isShowLabel: true,
    isRequired: { value: false, message: "" },
    tooltip: { enabled: false, text: "" },
    defaultValue: "(00)000000",
    input: {
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#fff",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#fff",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#434e5a33",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434e5a33",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "16",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    isPrefix: true,
    country: "AM",
    search: "",
    validations: {
      MIN_MAX_STRING_LENGTH: {
        enabled: false,
        min: 0,
        max: 0,
        validateBy: "LENGTH",
        message: "",
      },
    },
    icon: {
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#33bfa1",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#33bfa1",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "24",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
  },
  INPUT_NUMBER: {
    label: {
      value: "Number",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    input: {
      data: { contentType: "placeholder" },
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#fff",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#fff",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#434e5a33",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434e5a33",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "16",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    placeholder: "Write number",
    defaultValue: "0",
    isShowLabel: true,
    isRequired: { value: false, message: "" },
    arrows: false,
    tooltip: { enabled: false, text: "" },
    validations: {
      MIN_MAX_QUANTITY: {
        enabled: false,
        min: 0,
        max: 0,
        validateBy: "LENGTH",
        message: "",
      },
    },
    value: { enabled: false, min: 0, max: 0 },
    icon: {
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#33bfa1",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#33bfa1",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "20",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
  },
  DATE: {
    label: {
      value: "Date",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    input: {
      data: {
        contentType: "placeholder",
        defaultText: "MM/DD/YYYY",
        placeholder: "MM/DD/YYYY",
      },
      styles: {
        input: {
          widthPx: null,
          widthPercent: 50,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#fff",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#fff",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#434e5a33",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434e5a33",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "16",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    isShowLabel: true,
    isRequired: { value: false, message: "" },
    tooltip: { enabled: false, text: "" },
    isActive: false,
    validations: {
      MIN_MAX_DATE: {
        min: { option: "past", value: "" },
        max: { option: "future", value: "" },
        enabled: false,
        message: "",
      },
    },
    icon: {
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#33bfa1",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#33bfa1",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "24",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
  },
  SELECT_STAR_RATING: {
    label: {
      value: "Star Rating",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    starsCount: 6,
    defaultValue: 4,
    isShowLabel: true,
    isRequired: { value: false, message: "" },
    tooltip: { enabled: false, text: "" },
    validations: [],
    isCircle: true,
    input: {
      data: {
        contentType: "placeholder",
        defaultText: "Default Text",
        placeholder: "",
      },
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 90,
                  green: 78,
                  hue: 0,
                  red: 67,
                  saturation: 0,
                  value: 97,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#434e5a",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434e5a",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "24",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
  },
  INPUT_URL: {
    label: {
      value: "URL",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    input: {
      data: {
        contentType: "placeholder",
        defaultText: "Default Text",
        placeholder: "https://www.website.com",
      },
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#fff",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#fff",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#434e5a33",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434e5a33",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "16",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    isShowLabel: true,
    isRequired: { value: false, message: "" },
    tooltip: { enabled: false, text: "" },
    validations: {},
  },
  INPUT_ADDRESS: {
    label: {
      value: "Address",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    address_1: {
      input: {
        data: {
          contentType: "placeholder",
          defaultText: "Default Text",
          placeholder: "Street Address",
        },
        styles: {
          input: {
            widthPx: null,
            widthPercent: 100,
            height: 44,
            widthMeasurement: "Percent",
            fill: {
              color: {
                isStyleVisible: true,
                solid: "#fff",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#fff",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 255,
                    green: 255,
                    hue: 0,
                    red: 255,
                    saturation: 0,
                    value: 100,
                  },
                },
              },
            },
            border: {
              radius: 8,
              size: 1,
              color: {
                isStyleVisible: true,
                solid: "#434e5a33",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#434e5a33",
                  type: 0,
                  value: {
                    alpha: 0.2,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
          },
          inputValue: {
            family: "Quicksand",
            weight: "400",
            size: "16",
            isItalic: false,
            isUnderline: false,
            isStrikethrough: false,
            alignment: "left",
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 0.6,
                  blue: 90,
                  green: 78,
                  hue: 0,
                  red: 67,
                  saturation: 0,
                  value: 97,
                },
              },
            },
          },
        },
      },
      label: {
        value: "Street Address",
        hidden: false,
        styles: {
          family: "Quicksand",
          weight: "500",
          size: "20",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "top_left",
          length: 0,
          color: {
            isStyleVisible: true,
            solid: "#434e5a",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434e5a",
              type: 0,
              value: {
                alpha: 1,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
      isRequired: { value: false, message: "" },
    },
    address_2: {
      input: {
        data: {
          contentType: "placeholder",
          defaultText: "Default Text",
          placeholder: "Street Address 2",
        },
        styles: {
          input: {
            widthPx: null,
            widthPercent: 100,
            height: 44,
            widthMeasurement: "Percent",
            fill: {
              color: {
                isStyleVisible: true,
                solid: "#fff",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#fff",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 255,
                    green: 255,
                    hue: 0,
                    red: 255,
                    saturation: 0,
                    value: 100,
                  },
                },
              },
            },
            border: {
              radius: 8,
              size: 1,
              color: {
                isStyleVisible: true,
                solid: "#434e5a33",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#434e5a33",
                  type: 0,
                  value: {
                    alpha: 0.2,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
          },
          inputValue: {
            family: "Quicksand",
            weight: "400",
            size: "16",
            isItalic: false,
            isUnderline: false,
            isStrikethrough: false,
            alignment: "left",
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 0.6,
                  blue: 90,
                  green: 78,
                  hue: 0,
                  red: 67,
                  saturation: 0,
                  value: 97,
                },
              },
            },
          },
        },
      },
      label: {
        value: "Street Address 2",
        hidden: false,
        styles: {
          family: "Quicksand",
          weight: "500",
          size: "20",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "top_left",
          length: 0,
          color: {
            isStyleVisible: true,
            solid: "#434e5a",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434e5a",
              type: 0,
              value: {
                alpha: 1,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
      isRequired: { value: false, message: "" },
    },
    city: {
      input: {
        data: {
          contentType: "placeholder",
          defaultText: "Default Text",
          placeholder: "City",
        },
        styles: {
          input: {
            widthPx: null,
            widthPercent: 50,
            height: 44,
            widthMeasurement: "Percent",
            fill: {
              color: {
                isStyleVisible: true,
                solid: "#fff",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#fff",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 255,
                    green: 255,
                    hue: 0,
                    red: 255,
                    saturation: 0,
                    value: 100,
                  },
                },
              },
            },
            border: {
              radius: 8,
              size: 1,
              color: {
                isStyleVisible: true,
                solid: "#434e5a33",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#434e5a33",
                  type: 0,
                  value: {
                    alpha: 0.2,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
          },
          inputValue: {
            family: "Quicksand",
            weight: "400",
            size: "16",
            isItalic: false,
            isUnderline: false,
            isStrikethrough: false,
            alignment: "left",
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 0.6,
                  blue: 90,
                  green: 78,
                  hue: 0,
                  red: 67,
                  saturation: 0,
                  value: 97,
                },
              },
            },
          },
        },
      },
      label: {
        value: "City",
        hidden: false,
        styles: {
          family: "Quicksand",
          weight: "500",
          size: "20",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "top_left",
          length: 0,
          color: {
            isStyleVisible: true,
            solid: "#434e5a",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434e5a",
              type: 0,
              value: {
                alpha: 1,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
      isRequired: { value: false, message: "" },
    },
    state: {
      input: {
        data: {
          contentType: "placeholder",
          defaultText: "Default Text",
          placeholder: "State",
        },
        styles: {
          input: {
            widthPx: null,
            widthPercent: 50,
            height: 44,
            widthMeasurement: "Percent",
            fill: {
              color: {
                isStyleVisible: true,
                solid: "#fff",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#fff",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 255,
                    green: 255,
                    hue: 0,
                    red: 255,
                    saturation: 0,
                    value: 100,
                  },
                },
              },
            },
            border: {
              radius: 8,
              size: 1,
              color: {
                isStyleVisible: true,
                solid: "#434e5a33",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#434e5a33",
                  type: 0,
                  value: {
                    alpha: 0.2,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
          },
          inputValue: {
            family: "Quicksand",
            weight: "400",
            size: "16",
            isItalic: false,
            isUnderline: false,
            isStrikethrough: false,
            alignment: "left",
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 0.6,
                  blue: 90,
                  green: 78,
                  hue: 0,
                  red: 67,
                  saturation: 0,
                  value: 97,
                },
              },
            },
          },
        },
      },
      label: {
        value: "State",
        hidden: false,
        styles: {
          family: "Quicksand",
          weight: "500",
          size: "20",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "top_left",
          length: 0,
          color: {
            isStyleVisible: true,
            solid: "#434e5a",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434e5a",
              type: 0,
              value: {
                alpha: 1,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
      isRequired: { value: false, message: "" },
    },
    zip_code: {
      input: {
        data: {
          contentType: "placeholder",
          defaultText: "Default Text",
          placeholder: "Zip Code",
        },
        styles: {
          input: {
            widthPx: null,
            widthPercent: 50,
            height: 44,
            widthMeasurement: "Percent",
            fill: {
              color: {
                isStyleVisible: true,
                solid: "#fff",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#fff",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 255,
                    green: 255,
                    hue: 0,
                    red: 255,
                    saturation: 0,
                    value: 100,
                  },
                },
              },
            },
            border: {
              radius: 8,
              size: 1,
              color: {
                isStyleVisible: true,
                solid: "#434e5a33",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#434e5a33",
                  type: 0,
                  value: {
                    alpha: 0.2,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
          },
          inputValue: {
            family: "Quicksand",
            weight: "400",
            size: "16",
            isItalic: false,
            isUnderline: false,
            isStrikethrough: false,
            alignment: "left",
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 0.6,
                  blue: 90,
                  green: 78,
                  hue: 0,
                  red: 67,
                  saturation: 0,
                  value: 97,
                },
              },
            },
          },
        },
      },
      label: {
        value: "Zip Code",
        hidden: false,
        styles: {
          family: "Quicksand",
          weight: "500",
          size: "20",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "top_left",
          length: 0,
          color: {
            isStyleVisible: true,
            solid: "#434e5a",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434e5a",
              type: 0,
              value: {
                alpha: 1,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
      isRequired: { value: false, message: "" },
    },
    country: {
      input: {
        data: {
          contentType: "placeholder",
          defaultText: null,
          placeholder: "Select Country",
        },
        styles: {
          input: {
            widthPx: null,
            widthPercent: 50,
            height: 44,
            widthMeasurement: "Percent",
            fill: {
              color: {
                isStyleVisible: true,
                solid: "#fff",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#fff",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 255,
                    green: 255,
                    hue: 0,
                    red: 255,
                    saturation: 0,
                    value: 100,
                  },
                },
              },
            },
            border: {
              radius: 8,
              size: 1,
              color: {
                isStyleVisible: true,
                solid: "#434e5a33",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#434e5a33",
                  type: 0,
                  value: {
                    alpha: 0.2,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
          },
          inputValue: {
            family: "Quicksand",
            weight: "400",
            size: "16",
            isItalic: false,
            isUnderline: false,
            isStrikethrough: false,
            alignment: "left",
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 0.6,
                  blue: 90,
                  green: 78,
                  hue: 0,
                  red: 67,
                  saturation: 0,
                  value: 97,
                },
              },
            },
          },
        },
      },
      label: {
        value: "Select Country",
        hidden: false,
        styles: {
          family: "Quicksand",
          weight: "500",
          size: "20",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "top_left",
          length: 0,
          color: {
            isStyleVisible: true,
            solid: "#434e5a",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434e5a",
              type: 0,
              value: {
                alpha: 1,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
      icon: {
        styles: {
          input: {
            widthPx: null,
            widthPercent: 100,
            height: 44,
            widthMeasurement: "Percent",
            fill: {
              color: {
                isStyleVisible: true,
                solid: "#434E5A",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#434E5A",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 255,
                    green: 255,
                    hue: 0,
                    red: 255,
                    saturation: 0,
                    value: 100,
                  },
                },
              },
            },
            border: {
              radius: 8,
              size: 1,
              color: {
                isStyleVisible: true,
                solid: "#33bfa1",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#33bfa1",
                  type: 0,
                  value: {
                    alpha: 0.2,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
          },
          inputValue: {
            family: "Quicksand",
            weight: "400",
            size: "20",
            isItalic: false,
            isUnderline: false,
            isStrikethrough: false,
            alignment: "left",
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 0.6,
                  blue: 90,
                  green: 78,
                  hue: 0,
                  red: 67,
                  saturation: 0,
                  value: 97,
                },
              },
            },
          },
        },
      },
      isRequired: { value: false, message: "" },
    },
    order: {
      address_1: true,
      address_2: true,
      city: true,
      state: true,
      zip_code: true,
      country: true,
    },
    isRequired: { value: false, message: "" },
    isShowLabel: true,
    tooltip: { enabled: false, text: "" },
    validations: {
      required: {
        SELECTED_ALL: false,
        address_1: false,
        address_2: false,
        city: false,
        state: false,
        zip_code: false,
        country: false,
      },
    },
  },
  INPUT_EMAIL: {
    label: {
      value: "Email",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    input: {
      data: {
        contentType: "placeholder",
        defaultText: "Example@example.com",
        placeholder: "Example@example.com",
      },
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#fff",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#fff",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#434e5a33",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434e5a33",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "16",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    isShowLabel: true,
    isRequired: { value: false, message: "" },
    tooltip: { enabled: false, text: "" },
    validations: {
      DOMAIN: { value: " ", enabled: false, message: "" },
      REGEX: {
        value: " ",
        enabled: false,
        message: "Write your regex error message.",
      },
    },
  },
  HEADING_TEXT: {
    label: {
      value: "Heading",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    isRequired: { value: false, message: "" },
    tooltip: { enabled: false, text: "" },
    isActive: true,
    isShowLabel: true,
    text: "Heading",
    validations: [],
    input: {
      styles: {
        input: {},
        inputValue: {
          family: "Quicksand",
          weight: "600",
          size: "24",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434e5a",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434e5a",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
  },
  SELECT_SCALE_RATING: {
    label: {
      value: "Scale Rating",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    tooltip: { enabled: false, text: "" },
    left: {
      label: "",
      input: {
        data: {
          contentType: "placeholder",
          defaultText: "Left",
          placeholder: "Left",
        },
        styles: {
          input: {
            widthPx: null,
            widthPercent: 100,
            height: 44,
            widthMeasurement: "Percent",
            fill: {
              color: {
                isStyleVisible: true,
                solid: "#fff",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#fff",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 255,
                    green: 255,
                    hue: 0,
                    red: 255,
                    saturation: 0,
                    value: 100,
                  },
                },
              },
            },
            border: {
              radius: 8,
              size: 1,
              color: {
                isStyleVisible: true,
                solid: "#434e5a33",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#434e5a33",
                  type: 0,
                  value: {
                    alpha: 0.2,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
          },
          inputValue: {
            family: "Quicksand",
            weight: "400",
            size: "16",
            isItalic: false,
            isUnderline: false,
            isStrikethrough: false,
            alignment: "left",
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 0.6,
                  blue: 90,
                  green: 78,
                  hue: 0,
                  red: 67,
                  saturation: 0,
                  value: 97,
                },
              },
            },
          },
        },
      },
      enabled: true,
    },
    middle: {
      label: "",
      input: {
        data: {
          contentType: "placeholder",
          defaultText: "Middle",
          placeholder: "Middle",
        },
        styles: {
          input: {
            widthPx: null,
            widthPercent: 100,
            height: 44,
            widthMeasurement: "Percent",
            fill: {
              color: {
                isStyleVisible: true,
                solid: "#fff",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#fff",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 255,
                    green: 255,
                    hue: 0,
                    red: 255,
                    saturation: 0,
                    value: 100,
                  },
                },
              },
            },
            border: {
              radius: 8,
              size: 1,
              color: {
                isStyleVisible: true,
                solid: "#434e5a33",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#434e5a33",
                  type: 0,
                  value: {
                    alpha: 0.2,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
          },
          inputValue: {
            family: "Quicksand",
            weight: "400",
            size: "16",
            isItalic: false,
            isUnderline: false,
            isStrikethrough: false,
            alignment: "left",
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 0.6,
                  blue: 90,
                  green: 78,
                  hue: 0,
                  red: 67,
                  saturation: 0,
                  value: 97,
                },
              },
            },
          },
        },
      },
      enabled: true,
    },
    right: {
      label: "",
      input: {
        data: {
          contentType: "placeholder",
          defaultText: "Right",
          placeholder: "Right",
        },
        styles: {
          input: {
            widthPx: null,
            widthPercent: 100,
            height: 44,
            widthMeasurement: "Percent",
            fill: {
              color: {
                isStyleVisible: true,
                solid: "#fff",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#fff",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 255,
                    green: 255,
                    hue: 0,
                    red: 255,
                    saturation: 0,
                    value: 100,
                  },
                },
              },
            },
            border: {
              radius: 8,
              size: 1,
              color: {
                isStyleVisible: true,
                solid: "#434e5a33",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#434e5a33",
                  type: 0,
                  value: {
                    alpha: 0.2,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
          },
          inputValue: {
            family: "Quicksand",
            weight: "400",
            size: "16",
            isItalic: false,
            isUnderline: false,
            isStrikethrough: false,
            alignment: "left",
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 0.6,
                  blue: 90,
                  green: 78,
                  hue: 0,
                  red: 67,
                  saturation: 0,
                  value: 97,
                },
              },
            },
          },
        },
      },
      enabled: true,
    },
    isRequired: { value: false, message: "" },
    defaultValue: null,
    startValue: 0,
    endValue: 10,
    input: {
      data: { contentType: "placeholder", defaultText: "", placeholder: "" },
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#434E5A99",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A99",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 90,
                  green: 78,
                  hue: 0,
                  red: 67,
                  saturation: 0,
                  value: 97,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#1DCFA9",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#1DCFA9",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "44",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
  },
  SELECT_TERM_AND_CONDITION: {
    label: {
      value: "Terms & Conditions",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    input: {
      data: { contentType: "placeholder", defaultText: "", placeholder: "" },
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#fff",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#fff",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#434e5a33",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434e5a33",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "16",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    isChecked: false,
    isRequired: { value: false, message: "" },
    tooltip: { enabled: false, text: "" },
    text: "I agree to the {Terms of Service}",
    url: "www.example.com",
    validations: [],
    icon: {
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#33bfa1",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#33bfa1",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "17",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
  },
  INPUT_PRICE: {
    label: {
      value: "Price",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    input: {
      data: {
        contentType: "placeholder",
        defaultText: "",
        placeholder: "Placeholder",
      },
      styles: {
        input: {
          widthPx: 216,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Px",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#fff",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#fff",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#434e5a33",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434e5a33",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "16",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    isRequired: { value: false, message: "" },
    validations: {
      MIN_MAX_QUANTITY: {
        enabled: false,
        min: 0,
        max: 0,
        validateBy: "LENGTH",
        message: "",
      },
    },
    tooltip: { enabled: false, text: "" },
    value: { enabled: false, min: 0, max: 0 },
    currency: {
      value: "USD",
      input: {
        data: {
          contentType: "placeholder",
          defaultText: "",
          placeholder: "Placeholder",
        },
        styles: {
          input: {
            widthPx: 216,
            widthPercent: 100,
            height: 44,
            widthMeasurement: "Px",
            fill: {
              color: {
                isStyleVisible: true,
                solid: "#fff",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#fff",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 255,
                    green: 255,
                    hue: 0,
                    red: 255,
                    saturation: 0,
                    value: 100,
                  },
                },
              },
            },
            border: {
              radius: 8,
              size: 1,
              color: {
                isStyleVisible: true,
                solid: "#434e5a33",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#434e5a33",
                  type: 0,
                  value: {
                    alpha: 0.2,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
          },
          inputValue: {
            family: "Quicksand",
            weight: "400",
            size: "16",
            isItalic: false,
            isUnderline: false,
            isStrikethrough: false,
            alignment: "left",
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 0.6,
                  blue: 90,
                  green: 78,
                  hue: 0,
                  red: 67,
                  saturation: 0,
                  value: 97,
                },
              },
            },
          },
        },
        icon: {
          styles: {
            input: {
              widthPx: null,
              widthPercent: 100,
              height: 44,
              widthMeasurement: "Percent",
              fill: {
                color: {
                  isStyleVisible: true,
                  solid: "#434E5A",
                  gradient: null,
                  imageUrl: null,
                  lastModified: {
                    style: "#434E5A",
                    type: 0,
                    value: {
                      alpha: 1,
                      blue: 255,
                      green: 255,
                      hue: 0,
                      red: 255,
                      saturation: 0,
                      value: 100,
                    },
                  },
                },
              },
              border: {
                radius: 8,
                size: 1,
                color: {
                  isStyleVisible: true,
                  solid: "#33bfa1",
                  gradient: null,
                  imageUrl: null,
                  lastModified: {
                    style: "#33bfa1",
                    type: 0,
                    value: {
                      alpha: 0.2,
                      blue: 90,
                      green: 78,
                      hue: 211,
                      red: 67,
                      saturation: 26,
                      value: 35,
                    },
                  },
                },
              },
            },
            inputValue: {
              family: "Quicksand",
              weight: "400",
              size: "20",
              isItalic: false,
              isUnderline: false,
              isStrikethrough: false,
              alignment: "left",
              color: {
                isStyleVisible: true,
                solid: "#434E5A",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#434E5A",
                  type: 0,
                  value: {
                    alpha: 0.6,
                    blue: 90,
                    green: 78,
                    hue: 0,
                    red: 67,
                    saturation: 0,
                    value: 97,
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  MAP: {
    label: {
      value: "Map",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    input: {
      data: {
        contentType: "placeholder",
        defaultText: "Default Text",
        placeholder: "",
      },
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#fff",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#fff",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#FFFFFF",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#FFFFFF",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "16",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    isRequired: { value: false, message: "" },
    center: { lat: 48.85837009999999, lng: 2.2944813 },
    zoom: 4,
    markers: null,
    tooltip: { enabled: false, text: "" },
    validations: [],
  },
  CUSTOM_HTML: {
    label: {
      value: "",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    input: {
      data: {
        contentType: "placeholder",
        defaultText: "Default Text",
        placeholder: "Placeholder",
      },
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#fff",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#fff",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#434e5a33",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434e5a33",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "16",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    html: '<p style="font-family: `Quicksand`;font-style: normal;font-weight: 400;font-size: 16px;line-height: 20px;display: flex;align-items: center;color: #434E5A;opacity: 0.6; margin: 0">This is Heading</p>  <p style="font-family: `Quicksand`;font-style: normal;font-weight: 400;font-size: 16px;line-height: 20px;display: flex;align-items: center;color: #434E5A;opacity: 0.6; margin: 0">This is a paragraph</p>',
    isRequired: { value: false, message: "" },
    tooltip: { enabled: false, text: "" },
    validations: [],
  },
  DESCRIPTION_TEXT: {
    label: {
      value: "Description",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    isRequired: { value: false, message: "" },
    tooltip: { enabled: false, text: "" },
    isActive: true,
    isShowLabel: true,
    html: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    validations: {},
    input: {
      styles: {
        input: {},
        inputValue: {
          family: "Quicksand",
          weight: "500",
          size: "16",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434e5a",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434e5a",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
  },
  TIME: {
    label: {
      value: "Time",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    input: {
      data: {
        contentType: "placeholder",
        defaultText: "12:00 ",
        placeholder: "HH:MM ",
      },
      styles: {
        input: {
          widthPx: 126,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Px",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#fff",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#fff",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#434e5a33",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434e5a33",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "16",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    isRequired: { value: false, message: "" },
    dropdown_input: {
      data: { contentType: "placeholder", defaultText: "", placeholder: "" },
      styles: {
        input: {
          widthPx: 72,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Px",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#fff",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#fff",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#434e5a33",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434e5a33",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "16",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
      icon: {
        styles: {
          input: {
            widthPx: null,
            widthPercent: 100,
            height: 44,
            widthMeasurement: "Percent",
            fill: {
              color: {
                isStyleVisible: true,
                solid: "#434E5A",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#434E5A",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 255,
                    green: 255,
                    hue: 0,
                    red: 255,
                    saturation: 0,
                    value: 100,
                  },
                },
              },
            },
            border: {
              radius: 8,
              size: 1,
              color: {
                isStyleVisible: true,
                solid: "#33bfa1",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#33bfa1",
                  type: 0,
                  value: {
                    alpha: 0.2,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
          },
          inputValue: {
            family: "Quicksand",
            weight: "400",
            size: "20",
            isItalic: false,
            isUnderline: false,
            isStrikethrough: false,
            alignment: "left",
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 0.6,
                  blue: 90,
                  green: 78,
                  hue: 0,
                  red: 67,
                  saturation: 0,
                  value: 97,
                },
              },
            },
          },
        },
      },
    },
    tooltip: { enabled: false, text: "" },
    validations: {
      MIN_MAX_DATE: {
        min: { option: "", value: "" },
        max: { option: "", value: "" },
        enabled: false,
        message: "",
      },
    },
  },
  SELECT_CHECKBOX: {
    label: {
      value: "Checkbox",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    input: {
      data: {
        contentType: "placeholder",
        defaultText: "Default Text",
        placeholder: "otherId",
      },
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#fff",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#fff",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#434e5a33",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434e5a33",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "16",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    isRequired: { value: false, message: "" },
    column_quantity: 2,
    tooltip: { enabled: false, text: "" },
    checkedOptions: "",
    options: null,
    validations: {
      MIN_MAX_OPTIONS: {
        enabled: false,
        min: 0,
        max: 0,
        validateBy: "LENGTH",
        message: "",
      },
    },
    icon: {
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#33bfa1",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#33bfa1",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "20",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    paymentOptions: {
      enabled: false,
      quantity: { enabled: false, value: 0 },
      custom: { enabled: false, value: [] },
    },
  },
  SELECT_RADIO: {
    label: {
      value: "Radio",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    input: {
      data: {
        contentType: "placeholder",
        defaultText: "Default Text",
        placeholder: "otherId",
      },
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#fff",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#ffffffff",
                type: 0,
                value: {
                  alpha: 0,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#434e5a33",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434e5a33",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "16",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    isRequired: { value: false, message: "" },
    column_quantity: 2,
    defaultValue: "selectedOptionId",
    options: null,
    tooltip: { enabled: false, text: "" },
    validations: {},
    icon: {
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 50,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#33bfa1",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#33bfa1",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "20",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    paymentOptions: {
      enabled: false,
      quantity: { enabled: false, value: 0 },
      custom: { enabled: false, value: [] },
    },
  },
  SELECT_DROPDOWN: {
    label: {
      value: "Dropdown",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    input: {
      data: {
        contentType: "placeholder",
        defaultText: "Default Text",
        placeholder: "Please Select",
      },
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#fff",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#fff",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#434e5a33",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434e5a33",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "16",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    isRequired: { value: false, message: "" },
    defaultValue: "selectedOptionId",
    options: null,
    tooltip: { enabled: false, text: "" },
    validations: [],
    icon: {
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#33bfa1",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#33bfa1",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "20",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    paymentOptions: {
      enabled: false,
      quantity: { enabled: false, value: 0 },
      custom: { enabled: false, value: [] },
    },
  },
  SIGNATURE: {
    label: {
      value: "Signature",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    input: {
      data: {
        contentType: "placeholder",
        defaultText: "Default Text",
        placeholder: "",
      },
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#fff",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#fff",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#434e5a33",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434e5a33",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "16",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    isRequired: { value: false, message: "" },
    tooltip: { enabled: false, text: "" },
    showLine: false,
    validations: {},
    icon: {
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#33bfa1",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#33bfa1",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "24",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
  },
  TIME_ZONE: {
    label: {
      value: "Timezone",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    input: {
      data: {
        contentType: "placeholder",
        defaultText: "",
        placeholder: "Timezone",
      },
      styles: {
        input: {
          widthPx: null,
          widthPercent: 50,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#fff",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#fff",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#434e5a33",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434e5a33",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "16",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    isRequired: { value: false, message: "" },
    byIpLocation: false,
    defaultValue: "",
    tooltip: { enabled: false, text: "" },
    validations: [],
    icon: {
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#33bfa1",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#33bfa1",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "24",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
  },
  INPUT_PROMOCODE: {
    label: {
      value: "Promo Code",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    input: {
      data: {
        contentType: "placeholder",
        defaultText: "Default Text",
        placeholder: "",
      },
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#fff",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#fff",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#434e5a33",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434e5a33",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "16",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    tooltip: { enabled: false, text: "" },
    isRequired: { message: "", value: false },
    defaultText: "",
    placeholder: "Enter a Promo Code",
    button: {
      enabled: true,
      defaultText: "Apply",
      styles: {
        input: {
          widthPx: 67,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Px",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#1DCFA9",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#1DCFA9",
                type: 0,
                value: {
                  alpha: 0.6,
                  blue: 90,
                  green: 78,
                  hue: 0,
                  red: 67,
                  saturation: 0,
                  value: 97,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: "0",
            color: {
              isStyleVisible: true,
              solid: "#434e5a33",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434e5a33",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "16",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#F8F8F8",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#F8F8F8",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    icon: {
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 50,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#33bfa1",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#33bfa1",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "20",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
  },
  SELECT_PAYMENT_METHOD: {
    label: {
      value: "Payment Method",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    placeholder: "",
    input: {
      data: {
        contentType: "placeholder",
        defaultText: "Default Text",
        placeholder: "Placeholder",
      },
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#fff",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#fff",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#434e5a33",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434e5a33",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "16",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    isRequired: { message: "", value: true },
    tooltip: { enabled: false, text: "" },
    icon: {
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 50,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#33bfa1",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#33bfa1",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "20",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "left",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
  },
  FILE: {
    label: {
      value: "File Upload",
      hidden: false,
      styles: {
        family: "Quicksand",
        weight: "500",
        size: "20",
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        alignment: "top_left",
        length: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a",
            type: 0,
            value: {
              alpha: 1,
              blue: 90,
              green: 78,
              hue: 0,
              red: 67,
              saturation: 0,
              value: 97,
            },
          },
        },
      },
    },
    input: {
      data: {
        contentType: "placeholder",
        defaultText: "Default Text",
        placeholder: "Placeholder",
      },
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#fff",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#fff",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 8,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#434e5a33",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434e5a33",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "20",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "center",
          color: {
            isStyleVisible: true,
            solid: "#434E5A",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#434E5A",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
    isRequired: { message: "", value: false },
    tooltip: { enabled: false, text: "" },
    validations: {
      MIN_MAX_SIZE: {
        sizeType: "",
        min: 0,
        max: 0,
        validateBy: "SIZE",
        enabled: false,
        message: "",
      },
      FILE_TYPE_FORMAT: {
        types: [],
        formats: [],
        fileTypeFormat: "",
        validateBy: "TYPE_FORMAT",
        enabled: false,
        message: "",
      },
    },
    isMultiple: false,
    icon: {
      styles: {
        input: {
          widthPx: null,
          widthPercent: 100,
          height: 44,
          widthMeasurement: "Percent",
          fill: {
            color: {
              isStyleVisible: true,
              solid: "#434E5A",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#434E5A",
                type: 0,
                value: {
                  alpha: 1,
                  blue: 255,
                  green: 255,
                  hue: 0,
                  red: 255,
                  saturation: 0,
                  value: 100,
                },
              },
            },
          },
          border: {
            radius: 50,
            size: 1,
            color: {
              isStyleVisible: true,
              solid: "#33bfa1",
              gradient: null,
              imageUrl: null,
              lastModified: {
                style: "#33bfa1",
                type: 0,
                value: {
                  alpha: 0.2,
                  blue: 90,
                  green: 78,
                  hue: 211,
                  red: 67,
                  saturation: 26,
                  value: 35,
                },
              },
            },
          },
        },
        inputValue: {
          family: "Quicksand",
          weight: "400",
          size: "35",
          isItalic: false,
          isUnderline: false,
          isStrikethrough: false,
          alignment: "center",
          color: {
            isStyleVisible: true,
            solid: "#1DCFA9",
            gradient: null,
            imageUrl: null,
            lastModified: {
              style: "#1DCFA9",
              type: 0,
              value: {
                alpha: 0.6,
                blue: 90,
                green: 78,
                hue: 0,
                red: 67,
                saturation: 0,
                value: 97,
              },
            },
          },
        },
      },
    },
  },
};
